export default {
  successTitle: {
    id: 'add_to_cart_overlay_success_title',
    defaultMessage: 'Added to cart',
  },
  errorTitle: {
    id: 'add_to_cart_overlay_error_title',
    defaultMessage: 'Not added to cart',
  },
  errorSubtitle: {
    id: 'cross_sell_toast_title_error',
    defaultMessage: 'Oops',
  },
  errorMessage: {
    id: 'cross_sell_toast_message_error',
    defaultMessage: 'Product not added to the cart.',
  },
  goesWellWith: {
    id: 'add_to_cart_overlay_goes_well_with',
    defaultMessage: 'Goes well with',
  },
  goToCartButton: {
    id: 'add_to_cart_overlay_cart_button',
    defaultMessage: 'Go to cart',
  },
  closeLabel: {
    id: 'add_to_cart_overlay_cart_close',
    defaultMessage: 'Close',
  },
} as const
